module.exports = __webpack_public_path__ + "static/media/3.faba52f7.png";